//** carNumberSearch
const initialState = {
  carNumber: null
}

const carNumber = (state = initialState, action) => {
  switch (action.type) {
    case "CAR_NUMBER":
      return { ...state, carNumber: action.val }
    default:
      return state
  }
}

export default carNumber
